export function collectUniqueFilterNames(
  aggregated: Array<{ name: string }> | undefined,
  fallbackValues: string[]
): string[] {
  const names = new Set<string>();

  aggregated?.forEach((item) => {
    if (item.name) {
      names.add(item.name);
    }
  });

  fallbackValues.forEach((value) => {
    if (value) {
      names.add(value);
    }
  });

  return Array.from(names).sort((a, b) => a.localeCompare(b));
}
